import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import useDataBean from '../../../../../../../core/services/dataBean/useDataBean';
import { _QuickCustomerType } from '../../../../../../../core/services/dataBean/QuickEntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const QuickTurnSelectCustomerType = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_QuickCustomerType);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDCustomerType === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDCustomerType,
                    label: found.DataBeanProperties.Name,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        instance.getCustomerTypeCatalog(null).then(
            (resp: any) => {
                if (resp) setLista(resp);
            }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDCustomerType,
        label: item.DataBeanProperties.Name,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Tipo de Atención"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona su tipo de Atención..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
